import { useEffect, useState, useReducer } from 'react';

const handleRuleConditon = (rule, formState) => {
    
    const formStateKeys = Object.keys(formState)
        .filter(key => key.includes(`input_${rule.fieldId}`));

    const formStateValues = new Set(formStateKeys.map((key) => formState[key]));

    if (!formStateValues.size) return false;
    
    switch (rule.operator) {
        case 'is' :            
            return (formStateValues.has(rule.value));

        case 'is not':
            return (!formStateValues.has(rule.value));

        // case 'greater than':

        //     break;
        // case 'less than':
        //     break;
        // case 'contains':
        //     break;
        // case 'starts with':
        //     break;
        // case 'ends with':
        //     break;
        default:
            return false;
    }
}



const useWpFormConditionalLogic = (conditionalLogic, formState) => {

    const [parsedLogic, setParsedLogic] = useState(null);
    const [conditionalState, setState] = useState(null);

    const conditionalStateOutcomes = ['show', 'hide']
    const [[successState, failureState], setOutcomeStates] = useState(conditionalStateOutcomes);
    
    useEffect(() => {
        if (conditionalLogic !== "\"\"" && conditionalLogic != null) {

            const { actionType, logicType, rules } = JSON.parse(conditionalLogic);

            // handles the outcome of the conditional logic based on the actionType
            if (actionType === 'show') {
                setOutcomeStates(['show', 'hide'])
            } else {
                setOutcomeStates(['hide', 'show'])
            }

            setParsedLogic({ actionType, logicType, rules });
        }
    }, [])

    useEffect(() => {
        if (parsedLogic !== null 
                && 'rules' in parsedLogic 
                && 'logicType' in parsedLogic ) {

            const { rules, logicType } = parsedLogic;
            
            // check the conditions of each rule. 
            const evaledRules = rules.map((rule) => handleRuleConditon(rule, formState))
            const evaledRulesSet = new Set(evaledRules);

            const anyConditionMet = (logicType === 'any') && evaledRulesSet.has(true);
            const allConditionMet = (logicType === 'all') && evaledRulesSet.has(true) && !evaledRulesSet.has(false); 

            if (anyConditionMet || allConditionMet) {
                setState(successState);
            } else {
                setState(failureState);
            }
            
        }

    }, [parsedLogic, formState])

    return conditionalState
}

export default useWpFormConditionalLogic;